module.exports = __webpack_public_path__ + "static/media/PermissionDeniedNew.85cdf39e.png";